import * as React from 'react';
import { Loader } from '@topconagriculture/loader';
import { usePlatformNotifications, useReadPlatformNotifications } from '../../hooks';
import { NotificationCard, NotificationList } from '../Notifications';
import { getUserCompany, isPlatformNotificationLegacy } from '../../utils';
import { useSelector } from 'react-redux';
import { getCountryList } from '@topconagriculture/country';
import { EmptyList, Placeholder } from '@topconagriculture/react-components';
import { useTranslation } from 'react-i18next';
const NotificationModalContent = ({ userLocale, config, notificationId, activeIndexList }) => {
    const { t } = useTranslation();
    const { notification, notifications, loading } = usePlatformNotifications({
        storageContainer: config.storageContainer,
        storageUrl: config.storageUrl,
        authToken: config.authToken,
        tenantId: config.tenantId,
        applicationId: config.applicationId,
        notificationId,
    });
    const { readNotificationsIds } = useReadPlatformNotifications();
    const notReadNotificationIds = activeIndexList.filter((active) => !readNotificationsIds.includes(active));
    const [selected, setSelected] = React.useState();
    React.useEffect(() => setSelected(notification), [notification]);
    const company = useSelector(getUserCompany);
    const countries = useSelector(getCountryList);
    const getCountryByCode = (code) => countries.find((country) => country.code === code);
    const country = getCountryByCode(company === null || company === void 0 ? void 0 : company.countryId) || navigator.language.slice(-2);
    const notifiableNotifications = notifications.filter((notification) => {
        var _a, _b;
        if (isPlatformNotificationLegacy(notification)) {
            return true;
        }
        const filter = notification.filters.find((obj) => obj.tenantId === config.tenantId);
        if (!filter) {
            return false;
        }
        if (filter.areas || filter.countries) {
            return ((_a = filter.countries) === null || _a === void 0 ? void 0 : _a.includes(country.code)) || ((_b = filter.areas) === null || _b === void 0 ? void 0 : _b.includes(country.geoArea || ''));
        }
        else if (filter.distributors) {
            if (!company) {
                return false;
            }
            return !!filter.distributors.find((distributor) => distributor.id === company.id);
        }
        return true;
    });
    if (loading) {
        return React.createElement(Loader, null);
    }
    return (React.createElement(EmptyList, { list: notifiableNotifications, emptyComponent: React.createElement(Placeholder, { iconName: 'drafts', small: true, iconFromMui: true, title: t('common:platform_notifications.empty_list') }) },
        React.createElement(NotificationList, { notifications: notifiableNotifications, selected: selected, setSelected: setSelected, activeIndexList: notReadNotificationIds }),
        React.createElement(NotificationCard, { notification: selected, userLocale: userLocale })));
};
export default NotificationModalContent;
//# sourceMappingURL=NotificationModalContent.js.map